import { getLifecycle } from 'service/utils';

const REDUCER_NAME = 'ORDERBOOK';

export const BUY_SELLING_ORDERBOOK = getLifecycle(REDUCER_NAME, 'BUY_SELLING_ORDER');
